import { call, put, takeLatest, } from 'redux-saga/effects';

import { fetchMe as actions, } from './actions';
import * as types from './types';
import { MeErrorType, } from './types';
import { repositories, } from 'api'
import { getErrorProperties, } from 'common/functions';

export {
    actions,
};

const me = new repositories.Me();

function* fetchMe() {
    try {
        const { data, } = yield call([ me, 'get', ]);

        yield put(actions.success(data));
    } catch (error) {
        yield put(actions.failure(getErrorProperties<MeErrorType>(error)));
    }
}

function* meSaga() {
    yield takeLatest(types.FETCH_ME_REQUEST, fetchMe);
}

export default meSaga;
